import IMask from 'imask';
import { COUNTRY_CODES, getCountryMask, } from '@che-ins-ui/phone-input';
import { convertDateFromStateToISO } from '@che-ins-ui/datepicker';
import { ROUTES } from '@/components/routes';
import { isIframe } from '@/libs/helpers';
import { getInitialUrl } from '@/libs/hooks/useInitialUrlCookie';
import { BASE_PATH } from '@/libs/constants';
import { emailsSelector, insurerFormsSelector, passengersForApiSelector, } from '../forms/selectors';
import { transformInsurerForApi } from '../forms/helpers';
import { flightsFormsSelector } from '../flights/selectors';
import { marketingParamsSelector } from '../marketing';
export const getOrderBody = async (state) => {
    const passengers = passengersForApiSelector(state);
    const insurer = insurerFormsSelector(state);
    const flights = flightsFormsSelector(state);
    const { partnerId, marker, marker2, marker3, marker4, srcsale } = marketingParamsSelector(state);
    const returnUrlAfterPayment = [
        window.location.origin,
        BASE_PATH,
        ROUTES.success,
        '?',
    ].join('');
    const emails = emailsSelector(state);
    const [email] = emails.map(({ value }) => value);
    const { phoneCountryCode, phoneBody } = insurer;
    const phone = phoneCountryCode + phoneBody.replace(/\D/g, '');
    const body = {
        insurer: transformInsurerForApi(insurer),
        insureds: passengers.map(({ lastName, firstName, birthday }) => ({
            lastName,
            firstName,
            birthday,
        })),
        flights: flights.map((flight) => ({
            airlineCode: flight.airlineCode || '',
            flightNumber: flight.flightNumber,
            departureAirport: flight.fromCode || '',
            departureDate: convertDateFromStateToISO(flight.dateFrom),
            departureTime: flight.timeFrom,
            arrivalAirport: flight.toCode || '',
            arrivalDate: convertDateFromStateToISO(flight.dateTo),
            arrivalTime: flight.timeTo,
        })),
        email,
        phone,
        phoneCountryCode: Number(phoneCountryCode),
        returnUrlAfterPayment,
        initialUrl: isIframe() ? 'WL' : getInitialUrl(),
        ...(partnerId && {
            partnerId,
            marker,
            marker2,
            marker3,
            marker4,
        }),
        ...(srcsale && { affiliateTool: srcsale }),
    };
    return body;
};
export const getMaskValue = (phone) => {
    return getCountryMask(COUNTRY_CODES.find((country) => country.countryCode === Number(phone)));
};
export const preparePhoneCodeCountryAndPhoneForStore = (phoneFull, phoneCountryCode) => {
    let phoneForStore = '', phoneCountryCodeForStore = '';
    if (phoneFull &&
        phoneCountryCode &&
        phoneFull.startsWith(String(phoneCountryCode))) {
        phoneCountryCodeForStore = String(phoneCountryCode);
        phoneForStore = phoneFull.replace(String(phoneCountryCode), '');
        phoneForStore = IMask.createMask({
            mask: getMaskValue(phoneCountryCodeForStore),
        }).resolve(phoneForStore);
    }
    if (phoneFull && !phoneCountryCode && phoneFull.startsWith('7')) {
        phoneCountryCodeForStore = '7';
        phoneForStore = phoneFull.replace('7', '');
        phoneForStore = IMask.createMask({
            mask: getMaskValue(phoneCountryCodeForStore),
        }).resolve(phoneForStore);
    }
    if (phoneFull && !phoneCountryCode && !phoneFull.startsWith('7')) {
        phoneCountryCodeForStore = '';
        phoneForStore = phoneFull;
    }
    return {
        phoneCountryCode: phoneCountryCodeForStore,
        phoneBody: phoneForStore,
    };
};
